import {Injectable} from '@angular/core';
import {AppService} from '../../app.service';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DesignerFilterService extends AppService {
    className: string = 'DesignerFilterService';
    url: string = '/factor/front_filter';

    /**
     * Сохранение записи
     * @param data данные
     */
    public saveItem(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/save', data, this._httpOptions);
    }

    /**
     * Получение записи
     * @param data данные
     */
    public getItem(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/get_item', data, this._httpOptions);
    }

    /**
     * Получение структуры сущности
     * @param data данные
     */
    public getEntityStructure(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/fetch_entity_structure', data, this._httpOptions);
    }

    /**
     * Сохранение записи
     * @param data данные
     */
    public save(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/save', data, this._httpOptions);
    }

    /**
     * Копирование записи
     * @param data данные
     */
    public copyItem(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/copy_item', data, this._httpOptions);
    }

    /**
     * Удаление записи реестра записи
     * @param data данные
     */
    public remove(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/delete', data, this._httpOptions);
    }
}
